module.exports = __webpack_public_path__ + "img/wl_summary_Image.ca235968.png";